import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useModal } from "./ModalContext";
import { isUserRegistered } from "../utils/userSession";

const SECTIONS_REQUIRED = 2;
const ADMIN_PATH_PREFIX = "/admin";

const getPageSections = () =>
  document.querySelectorAll(".dody-container .e-con.e-parent");

const hasPassedRequiredSections = () => {
  const sections = getPageSections();

  if (sections.length >= SECTIONS_REQUIRED) {
    const targetSection = sections[SECTIONS_REQUIRED - 1];
    return targetSection.getBoundingClientRect().bottom <= 0;
  }

  return window.scrollY >= window.innerHeight * SECTIONS_REQUIRED;
};

const useScrollSectionGate = () => {
  const location = useLocation();
  const { openModal, setScrollGatePassed } = useModal();
  const autoShownRef = useRef(false);
  const hasScrolledRef = useRef(false);

  useEffect(() => {
    autoShownRef.current = false;
    hasScrolledRef.current = false;
    setScrollGatePassed(false);

    const sessionKey = "biome_scroll_register_popup_shown";
    const alreadyShown = sessionStorage.getItem(sessionKey) === "true";

    if (
      location.pathname.startsWith(ADMIN_PATH_PREFIX) ||
      isUserRegistered() ||
      alreadyShown
    ) {
      setScrollGatePassed(true);
      return undefined;
    }

    const evaluateScrollGate = () => {
      if (hasPassedRequiredSections()) {
        setScrollGatePassed(true);

        if (hasScrolledRef.current && !autoShownRef.current) {
          autoShownRef.current = true;
          sessionStorage.setItem(sessionKey, "true");
          openModal("");
        }
      }
    };

    const handleScroll = () => {
      hasScrolledRef.current = true;
      evaluateScrollGate();
    };

    evaluateScrollGate();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname, openModal, setScrollGatePassed]);
};

export default useScrollSectionGate;
